import { render, staticRenderFns } from "./StepA.vue?vue&type=template&id=a9f4048c&scoped=true"
import script from "./StepA.vue?vue&type=script&lang=js"
export * from "./StepA.vue?vue&type=script&lang=js"
import style0 from "./StepA.vue?vue&type=style&index=0&id=a9f4048c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9f4048c",
  null
  
)

export default component.exports